export type permissionFormDataType =
  | 'type'
  | 'allPermissions'
  | 'staffPermissions'
  | 'salesAccountManagerPermissions'
  | 'salesServiceRepPermissions'
  | 'jjEmployeePermissions'
  | 'flexPayPermission'
  | 'compliancePermission'
  | 'gamingReportsPermission'
  | 'playerPaybackPermission'
  | 'patronCheckInsPermission'
  | 'rewardsPermission'
  | 'promotionsPermission'
  | 'sweepstakesPermission'
  | 'enrollInSweepstakesPermission'
  | 'locationSweepstakesPermission'
  | 'playerPaybackReportsPermission'
  | 'locationsPermission'
  | 'leUsersPermission'
  | 'contactUsPermission'
  | 'reportsAccessToPIIPermission'
  | 'reportsDownloadPIIPermission'
  | 'badgeRewardsPermission'
  | 'badgeLocationsPermission'

export const isPermissionOwner = (permission: any): boolean => {
  if (!permission) {
    return false
  }
  const isOwner =
    permission.flexPayPermission &&
    permission.compliancePermission &&
    permission.gamingReportsPermission &&
    permission.playerPaybackPermission &&
    permission.patronCheckInsPermission &&
    permission.rewardsPermission &&
    permission.promotionsPermission &&
    permission.sweepstakesPermission &&
    permission.enrollInSweepstakesPermission &&
    permission.locationSweepstakesPermission &&
    permission.playerPaybackReportsPermission &&
    permission.locationsPermission &&
    permission.leUsersPermission &&
    permission.contactUsPermission &&
    permission.reportsAccessToPIIPermission &&
    permission.reportsDownloadPIIPermission &&
    permission.badgeRewardsPermission &&
    permission.badgeLocationsPermission

  return isOwner
}

export const isPermissionStaff = (permission: any): boolean => {
  if (!permission) {
    return false
  }

  const isStaff =
    !permission.flexPayPermission &&
    permission.compliancePermission &&
    !permission.gamingReportsPermission &&
    permission.playerPaybackPermission &&
    !permission.patronCheckInsPermission &&
    !permission.rewardsPermission &&
    permission.promotionsPermission &&
    !permission.sweepstakesPermission &&
    !permission.enrollInSweepstakesPermission &&
    permission.locationSweepstakesPermission &&
    permission.playerPaybackReportsPermission &&
    !permission.locationsPermission &&
    !permission.leUsersPermission &&
    !permission.contactUsPermission &&
    !permission.reportsAccessToPIIPermission &&
    !permission.reportsDownloadPIIPermission &&
    !permission.badgeRewardsPermission &&
    !permission.badgeLocationsPermission

  return isStaff
}

export const isPermissionSalesAccountManager = (permission: any): boolean => {
  if (!permission) {
    return false
  }
  const isSalesAccountMager =
    permission.flexPayPermission &&
    permission.compliancePermission &&
    permission.gamingReportsPermission &&
    permission.playerPaybackPermission &&
    permission.patronCheckInsPermission &&
    permission.rewardsPermission &&
    permission.promotionsPermission &&
    permission.sweepstakesPermission &&
    permission.enrollInSweepstakesPermission &&
    permission.locationSweepstakesPermission &&
    permission.playerPaybackReportsPermission &&
    permission.locationsPermission &&
    permission.leUsersPermission &&
    permission.contactUsPermission &&
    !permission.reportsAccessToPIIPermission &&
    !permission.reportsDownloadPIIPermission &&
    !permission.badgeRewardsPermission &&
    permission.badgeLocationsPermission

  return isSalesAccountMager
}

export const isPermissionSalesServiceRep = (permission: any): boolean => {
  if (!permission) {
    return false
  }
  const isSalesServiceRep =
    permission.flexPayPermission &&
    permission.compliancePermission &&
    permission.gamingReportsPermission &&
    permission.playerPaybackPermission &&
    permission.patronCheckInsPermission &&
    permission.rewardsPermission &&
    permission.promotionsPermission &&
    permission.sweepstakesPermission &&
    permission.enrollInSweepstakesPermission &&
    permission.locationSweepstakesPermission &&
    permission.playerPaybackReportsPermission &&
    permission.locationsPermission &&
    permission.leUsersPermission &&
    permission.contactUsPermission &&
    !permission.reportsAccessToPIIPermission &&
    !permission.reportsDownloadPIIPermission &&
    !permission.badgeRewardsPermission &&
    permission.badgeLocationsPermission

  return isSalesServiceRep
}

export const isPermissionJJEmployee = (permission: any): boolean => {
  if (!permission) {
    return false
  }
  const isJJEmployee =
    permission.flexPayPermission &&
    permission.compliancePermission &&
    permission.gamingReportsPermission &&
    permission.playerPaybackPermission &&
    permission.patronCheckInsPermission &&
    permission.rewardsPermission &&
    permission.promotionsPermission &&
    permission.sweepstakesPermission &&
    permission.enrollInSweepstakesPermission &&
    permission.locationSweepstakesPermission &&
    permission.playerPaybackReportsPermission &&
    permission.locationsPermission &&
    permission.leUsersPermission &&
    permission.contactUsPermission &&
    !permission.reportsAccessToPIIPermission &&
    !permission.reportsDownloadPIIPermission &&
    !permission.badgeRewardsPermission &&
    permission.badgeLocationsPermission

  return isJJEmployee
}

export const isPermissionCustom = (permission: any): boolean => {
  if (!permission) {
    return false
  }

  const isOwner = isPermissionOwner(permission)
  const isStaff = isPermissionStaff(permission)
  const isSalesAccountManager = isPermissionSalesAccountManager(permission)
  const isSalesServiceRep = isPermissionSalesServiceRep(permission)
  const isJJEmployee = isPermissionJJEmployee(permission)

  return (
    !isOwner &&
    !isStaff &&
    !isSalesAccountManager &&
    !isSalesServiceRep &&
    !isJJEmployee
  )
}
